import '../../../node_modules/tachyons/css/tachyons.css'
import React, { Component } from 'react'
import { Switch, withRouter } from 'react-router-dom'
import { TransitionGroup } from 'react-transition-group'
import Theme from '../../components/Theme/Theme'
import UniversalRoute from '../../components/UniversalRoute/UniversalRoute'
import PushTransition from '../../components/PushTransition/PushTransition'
import NavBar from '../../components/NavBar/NavBar'
import routes from '../../routes'
import './App.css'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      totalScore: 0,
      currentStep: 1,
      nextStep: 'barnets-alder',
      currentStepDone: false,
      totalSteps: 8,
      selectedSex: null,
      currentSelectedAnswer: null,
      answers: {
        1: 'gutt',
        2: '5 år',
        3: 'ikke er noe problem',
        4: '3 ganger',
        5: 'litt',
        6: 'ikke bruker bleie',
        7: 'ikke oppsøkt lege tidligere',
        8: 'om natten',
      },
    }
    this.updateScore = this.updateScore.bind(this)
    this.initStep = this.initStep.bind(this)
  }

  initStep(currentStep, nextStep) {
    this.setState(prevState => ({
      currentStep,
      nextStep,
      currentSelectedAnswer: null,
      currentStepDone: false,
    }))
  }

  updateScore(score, currentSelectedAnswer, stepNumber, answerString) {
    this.setState(({ totalScore, selectedSex, answers }) => ({
      totalScore: totalScore + score,
      currentStepDone: true,
      currentSelectedAnswer,
      answers: {
        ...answers,
        [stepNumber]: answerString,
      },
      selectedSex: selectedSex || (score === 1.001 ? 'jente' : 'gutt'),
    }))
  }

  render() {
    const { location } = this.props

    return (
      <Theme>
        <TransitionGroup className="relative h-100">
          <PushTransition key={location.key}>
            <Switch location={location}>
              {routes.map(route => (
                <UniversalRoute
                  {...route}
                  key={location.key || location.pathname}
                  initialData={this.props.initialData}
                  updateScore={this.updateScore}
                  initStep={this.initStep}
                  {...this.state}
                />
              ))}
            </Switch>
          </PushTransition>
        </TransitionGroup>
        {location.pathname === '/' ||
        location.pathname === '/steg/konklusjon' ||
        location.pathname === '/faq' ? null : (
          <NavBar {...this.state} />
        )}
      </Theme>
    )
  }
}

// Export unwrapped App for testing
export const Unwrapped = App
// Export with router to get access to location etc.
export default withRouter(App)



// WEBPACK FOOTER //
// ./src/containers/App/App.js